import { initializeApp } from 'firebase/app'
import { Analytics, getAnalytics, logEvent } from 'firebase/analytics'
import { FIREBASE_CONFIG, IS_PROD } from 'config'

const firebaseConfig = JSON.parse(FIREBASE_CONFIG as string)

export const firebaseApp = initializeApp(firebaseConfig)

let firebaseAnalytics: Analytics | undefined

export const captureFirebase = (event: string, properties?: Record<string, unknown>) => {
  if (!IS_PROD) return
  if (!firebaseAnalytics) firebaseAnalytics = getAnalytics(firebaseApp)
  logEvent(firebaseAnalytics, event, properties)
}
